import { render } from "./DownloadIcon.vue?vue&type=template&id=4f3cc082&scoped=true"
import script from "./DownloadIcon.vue?vue&type=script&lang=js"
export * from "./DownloadIcon.vue?vue&type=script&lang=js"

import "./DownloadIcon.vue?vue&type=style&index=0&id=4f3cc082&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3cc082"]])

export default __exports__